<template>
    <section
        class="signin section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="signin-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header tag="h1" :data="sectionHeader" class="center-content" />
                
                <div class="tiles-wrap">
                    <div class="tiles-item">
                        <div class="tiles-item-inner">
                            <form @submit.prevent="login">
                                <fieldset>
                                    <div class="mb-12">
                                        <c-input
                                            type="email"
                                            label="Email"
                                            placeholder="Email"
                                            @focus="sectionHeader.paragraph = ''"
                                            @blur="sectionHeader.paragraph = ''"
                                            v-model="email"
                                            label-hidden
                                            required 
                                        />
                                    </div>
                                    <!--<div class="mb-12">
                                        <c-input
                                            type="password"
                                            label="Password"
                                            placeholder="Password"
                                            label-hidden
                                            required />
                                    </div>-->
                                    <div class="mt-24 mb-32">
                                        <c-button color="primary" :loading="inprogress" wide>{{inprogress ? '' : 'Sign in'}}</c-button>
                                    </div>
                                    <!--<div class="signin-footer mb-32">
                                        <c-checkbox>Remember me</c-checkbox>
                                        <router-link to="/recover-password/" class="func-link text-xs">Forgot password?</router-link>
                                    </div>-->
                                </fieldset>
                            </form>
                            <div class="signin-bottom has-top-divider">
                                <div class="pt-32 text-xs center-content text-color-low">
                                    Don't you have an account? <router-link to="/signup/" class="func-link">Sign up</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CInput from '@/components/elements/Input.vue'
import CButton from '@/components/elements/Button.vue'
//import CCheckbox from '@/components/elements/Checkbox.vue'
import { Magic } from 'magic-sdk'
import axios from 'axios';

const m = new Magic(process.env.VUE_APP_MAGIC_KEY);


export default {
  name: 'CSignupForm',
  components: {
    CSectionHeader,
    CInput,
    CButton,
    //CCheckbox
  },
  mixins: [SectionProps],
  mounted() {
    m.preload();
  },
  data() {
    return {
      email: '',
      inprogress: false,
      sectionHeader: {
        title: 'Welcome back!',
        paragraph: ''
      },
      message: ''
    }
  },
  methods: {
    login() {
      this.inprogress = true;
       // check if user exists
      axios.post(
        process.env.VUE_APP_API_URL + 'users/exists',
        {
            email_id: this.email
        }
      )
      .then((res) => {
        /* eslint-disable no-console */
        if (res.data != null) {
          this.$store
          .dispatch('login', {
            email: this.email,
            showUI: true
          })
          .then(() => {
            this.inprogress = false;
            window.location.href = '/dashboard/';
          })
          .catch((err) => {
            this.inprogress = false;
            /* eslint-disable no-console */
            console.log(err)
          });
        } else {
          this.sectionHeader.paragraph = 'We couldn\'t find a user with that email'
          this.inprogress = false;
        }
      })
      .catch((err) => {
        /* eslint-disable no-console */
        console.log(err);
        this.inprogress = false;
      });
   },
 },
}
</script>